import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";

export const DesignerSlice = createSlice({
 name: "Designer",
 initialState: {
  error: false,
  commData:[],
  campData: [],
  loading: false,
 },
 reducers:{
     setCommData: (state, { payload }) => {
         state.commData = payload;
     },
     setCampData: (state, { payload }) => {
         state.campData = payload;
     },
     setLoading: (state, { payload }) => {
         state.loading = payload;
     },
     setError: (state) => {
         state.error = true;
     },
 },
});

// Action creators are generated for each case reducer function
export const {
 setError,
 setCommData,
 setCampData,
 setLoading,
} = DesignerSlice.actions;


export default DesignerSlice.reducer;

export function fetchDesignerWorkItems(user) {
 return (dispatch) => {
  axios
   .get(`${baseURL}/designer/workItems/communications/${user}`)
   .then((response) => {
    dispatch(setCommData(response.data));
   })
   .catch((err) => {
    // then print response status
    console.error("fetching designer's  fail", err);
    dispatch(setError(err));
   });
 };
}
